import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { API, DATE } from '@const'
import { Button, Grid } from '@material-ui/core'
import { Search } from '@material-ui/icons'
import Table from '@tables/table'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
import 'antd/dist/antd.css'
import { PfSubPfSelect, RankingsTypeSelect } from '@select'
import { store } from '@redux/store'
import moment from 'moment'
import { addToast } from '../../utils/toast'

const COMPONENT_GROUP = 'game_ranking_list'
class GameRankingList extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'GameRankingList')
        }
    }

    state = {
        editRankings: false,
        data: {},
        assignData: {},
        rankinputs: {},
        originSort: []
    }

    columns = [
        {
            field: 'currency',
            render: (rowData) => {
                return <div>{rowData.currency}</div>
            },
        },
        {
            field: 'rankingsType',
            render: (rowData) => {
                return <div>{rowData.rankingsType}</div>
            },
        },
        {
            field: 'rankings',
            render: (rowData) => {
                return <div>{rowData.rank}</div>
            },
        },
        {
            field: 'chineseName',
            render: (rowData) => {
                return <div>{rowData.chineseName}</div>
            },
        },
        {
            field: 'englishName',
            render: (rowData) => {
                return <div>{rowData.englishName}</div>
            },
        },
        {
            field: 'game_code',
            render: (rowData) => {
                return this.state.editRankings ? (
                    <div>
                        <input
                            id={rowData.game_code + '-input'}
                            value={this.state.rankinputs[rowData.game_code] || ''}
                            onChange={(event) => {
                                /** 排名輸入0會變空字串 */
                                let value = Number(event.target.value.replace(/[^\d]/g, '')) || ''
                                /** 輸入的排名大於總數量會直接代入最後一位 */
                                value = value > this.state.data.rank_info.length ? this.state.data.rank_info.length : value
                                this.setState(
                                    {
                                        rankinputs: {
                                            ...this.state.rankinputs,
                                            [rowData.game_code]: value,
                                        },
                                    }, () => {
                                        /** 刷新table */
                                        this.table.setDataDisplay()
                                    }
                                )
                            }}
                            className={this.props.classes.sortInput}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                if (this.state.rankinputs[rowData.game_code]) {
                                    const newRank = Number(this.state.rankinputs[rowData.game_code])
                                    if (newRank === 0) return
                                    if (newRank > this.state.data.rank_info.length) {
                                        addToast(this.t('sortQuantityOverload'), 'error')
                                        return
                                    }
                                    this.sortRank(rowData.game_code, newRank)
                                }
                            }}
                            className={this.props.classes.sortButton}>
                            {this.t('confirm')}
                        </Button>
                    </div>
                ) : (
                    <></>
                )
            },
            cellStyle: {
                width: '195px',
            },
        },
    ]

    sortRank(gameCode, newRank) {
        const currentObject = this.state.data.rank_info.find((item) => item.game_code === gameCode)
        const cloneData = JSON.parse(JSON.stringify(this.state.data.rank_info))
        const currentRank = currentObject.rank
        if (currentObject) {
            if (currentRank === newRank || newRank === 0) return
            cloneData.forEach((item) => {
                const isCurrentGame_code = item.game_code === gameCode // 是否為要變更排名的 item
                if (isCurrentGame_code) {
                    item.rank = newRank
                    return
                }
                if (item.rank > currentRank && item.rank <= newRank) {
                    item.rank--
                }
                if (item.rank < currentRank && item.rank >= newRank) {
                    item.rank++
                }
            })

            cloneData.sort((a, b) => a.rank - b.rank)
            this.formatExportKey({ ...this.state.data, rank_info: cloneData })
            /** 清除執行移動排序的欄位 */
            const rankinputs = {
                ...this.state.rankinputs,
                [gameCode]: ''
            }
            this.setState({
                rankinputs,
                data: { ...this.state.data, rank_info: cloneData }
            }, () => {
                this.table.SetData(this.state.data.rank_info)
            })
        }
    }

    formatExportKey(data) {
        data.rank_info.forEach((item) => {
            const game = store.getState().dataService.gameList.find((gameListitem) => gameListitem.game_code === item.game_code)
            item.currency = utils.getPfCurrency(data.pf_id)
            item.rankingsType = data.rank_type
            item.rankings = item.rank
            item.chineseName = utils.t('GameName.' + game.game_code, '', { lng: 'zh' })
            item.englishName = utils.t('GameName.' + game.game_code, '', { lng: 'en' })
        })
        return data.rank_info
    }

    queryData() {
        this.switchEditRankings(false)
        this.table.SetLoading(true)
        utils.apiRequest(
            'get',
            API.GAME_RANK,
            {
                pf_id: this.PfSubPfSelect.state.pfId,
                rank_type: this.rankingsTypeSelect.state.type.toLowerCase(),
            },
            (data) => {
                data.rank_info = this.formatExportKey(data)
                this.initRankinputs(data)
                this.setRankInfo(data)
            },
            (_err) => {
                this.table.SetData([])
            },
            true
        )
    }

    updateData() {
        this.table.SetLoading(true)
        /** 比對排序有無變更 */
        let hasChange = false
        this.state.data.rank_info.forEach((item, index) => {
            if ((item.game_code !== this.state.assignData[index].game_code)) {
                hasChange = true
            }
        })
        if (!hasChange) {
            this.table.SetLoading(false)
            this.switchEditRankings(false)
            this.resetRankinputs()
            return
        }
        utils.apiRequest(
            'put',
            API.GAME_RANK,
            this.state.data,
            (_data) => {
                this.queryData()
                this.switchEditRankings(false)
            },
            (_err) => {
                this.table.SetData([])
            },
            true
        )
    }

    reRankData() {
        this.switchEditRankings(false)
        this.table.SetLoading(true)
        utils.apiRequest(
            'post',
            API.GAME_RANK_RERANK,
            this.state.data,
            (_data) => {
                this.queryData()
                this.switchEditRankings(false)
            },
            (_err) => {
                this.table.SetData([])
            },
            true
        )
    }

    setRankInfo(data) {
        this.setState({ data, assignData: JSON.parse(JSON.stringify(data.rank_info)) }, () => {
            this.table.SetData(this.state.data.rank_info)
        })
    }

    switchEditRankings(editRankings) {
        this.setState({ editRankings }, () => {
            this.table.SetData(this.state.data.rank_info)
        })
    }

    initRankinputs(data) {
        const rankinputs = {}
        data.rank_info.forEach(item => {
            rankinputs[item.game_code] = ''
        })
        this.setState({
            rankinputs
        }, () => {
            this.table.setDataDisplay()
        })
    }

    resetRankinputs() {
        const rankinputs = this.state.rankinputs
        Object.keys(rankinputs).forEach(key => {
            if (rankinputs[key]) {
                rankinputs[key] = ''
            }
        })
        this.setState({
            rankinputs
        }, () => {
            this.table.setDataDisplay()
        })
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item className={this.props.classes.alignCenter}>
                    <PfSubPfSelect onRef={(ref) => (this.PfSubPfSelect = ref)} options={{ hideAutocomplete: true, hideAllPlatform: true }} />
                </Grid>
                <Grid item className={this.props.classes.alignCenter}>
                    <RankingsTypeSelect onRef={(ref) => (this.rankingsTypeSelect = ref)} options={{ hideAll: false }} />
                </Grid>
                <Grid item className={this.props.classes.alignCenter}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            this.queryData()
                        }}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search', {})}
                    </Button>
                </Grid>
                <Grid item className={this.props.classes.alignCenter}>
                    {utils.checkValid(COMPONENT_GROUP + '.rerank') ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                this.reRankData()
                            }}>
                            {this.t('AuthAction.rerank')}
                        </Button>
                    ) : (
                        <></>
                    )}
                </Grid>
                <Grid item xs={12} className={this.props.classes.tableGrid}>
                    <div className={this.props.classes.rankingsInfo}>
                        {this.state.data.updated_at && (
                            <div>
                                <span className={this.props.classes.infoContent}>
                                    {utils.t('rank', 'EventDialog') + utils.t('updatedAt', 'EventPrizeDetailRedPacketDialog')} :
                                    {' ' + utils.unixToDateTime(this.state.data.updated_at) + ' ( GMT' + DATE.CLIENT_UTC_OFFSET + ' )'}
                                </span>
                                {this.state.editRankings ? (
                                    <>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className={this.props.classes.button}
                                            onClick={() => {
                                                this.updateData()
                                            }}>
                                            {this.t('send')}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            className={this.props.classes.button}
                                            onClick={() => {
                                                this.switchEditRankings(false)
                                                this.setState({
                                                    data: {
                                                        ...this.state.data,
                                                        rank_info: this.state.assignData,
                                                    }
                                                }, this.resetRankinputs())
                                            }}>
                                            {this.t('cancel')}
                                        </Button>
                                    </>
                                ) : utils.checkValid(COMPONENT_GROUP + '.edit') ? (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={this.props.classes.button}
                                        onClick={() => {
                                            this.switchEditRankings(true)
                                        }}>
                                        {this.t('edit') + utils.t('rank', 'EventDialog')}
                                    </Button>
                                ) : (
                                    <></>
                                )}
                            </div>
                        )}
                    </div>
                    <Table
                        ownerName="GameRankingList"
                        columns={this.columns}
                        options={{
                            exportButton: true,
                            export: true,
                            tableLayout: 'fixed',
                            downloadName: `GameRankReport${moment(this.state.data.updated_at)
                                .subtract(1, 'months')
                                .format('YYYY_MM')}_${utils.getPfCurrency(this.state.data.pf_id)}`,
                        }}
                        onRef={(ref) => (this.table = ref)}
                    />
                    <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
                </Grid>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        alignCenter: {
            display: 'inline-flex',
            alignItems: 'center',
        },
        button: {
            marginLeft: '10px',
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        tableGrid: {
            position: 'relative',
        },
        rankingsInfo: {
            position: 'absolute',
            top: '7px',
            left: '330px',
            zIndex: '1',
            height: '50px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        infoContent: {
            fontWeight: 'bold',
            fontSize: '16px',
        },
        sortInput: {
            width: '80px',
            height: '30px',
        },
        sortButton: {
            height: '30px',
            marginLeft: '15px',
            marginBottom: '5px',
        },
    }
}

GameRankingList.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
}

export default hoc(styles)(GameRankingList)
